import { StorageServiceTypes } from './types';

const StorageService: StorageServiceTypes = {
  getItem: key => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: key => localStorage.removeItem(key),
  clearStorage: () => localStorage.clear(),
};

export default StorageService;
